<template>
  <multiselect
      :value="selectedValue"
      @input="onInput"
      v-bind="$attrs"
      @remove="onRemove"
      @select="onSelect"
      :options="options"
      :track-by="trackBy"
      :label="label"
      :preserve-search="preserveSearch"
      :clear-on-select="clearOnSelect"
      :show-labels="showLabels"
      :loading="isLoading"
      :max-height="maxHeight"
      :internal-search="internalSearch"
      @search-change="searchChange"
      :disabled="disabled || (isLoading && !isSearching)"
  >
    <template v-slot:beforeList>
      <slot name="beforeList"></slot>
    </template>
    <template v-slot:option="props">
      <slot name="option" v-bind="props"></slot>
    </template>
  </multiselect>

</template>

<script>
import Multiselect from "vue-multiselect";
import _ from "lodash";

export default {
  name: "vue-delayed-multiselect-ajax",
  components: {
    Multiselect
  },
  props:{
    value: {
      type: [String, Number, Array],
      default: undefined
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    label: {
      type: String,
      default: 'name'
    },
    preserveSearch: {
      type: Boolean,
      default: true,
    },
    clearOnSelect: {
      type: Boolean,
      default: false
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: Number,
      default: 240
    },
    internalSearch: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: undefined
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    modifyResponse: {
      type: Function,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchKey: {
      type: String,
      default: 'search',
    }
  },
  data() {
    return {
      isLoading: false,
      isSearching: false,
      selectedValue: undefined,
      options: [],
      search: '',
      debounceFetchOptions: _.debounce(this.fetchOptions, 500)
    }
  },
  watch: {
    value: {
      immediate: false,
      handler(value) {
        if (this.$attrs.multiple) {
          if(value === undefined || value.length === 0) {
            this.selectedValue = undefined
          }
          if(this.isLoading) {
            return;
          }
          let selectedValue = this.options.filter((o) => (value || []).map(String).includes(String(_.get(o, this.trackBy) || '')));
          if (this.selectedValue && this.selectedValue.length && String(_.get(selectedValue, this.trackBy) || '') === String(_.get(this.selectedValue, this.trackBy) || '')) return;
          this.fetchOptions({ [this.trackBy + '__in']: value && (value || []).join(',') || undefined })
              .then(() => {
                this.selectedValue = this.options.filter((o) => (value || []).map(String).includes(String(_.get(o, this.trackBy) || '')));
              })
        } else {
          let selectedValue = this.options.find((o) => String(_.get(o, this.trackBy) || '') === String(value || ''));
          if (this.selectedValue && String(_.get(selectedValue, this.trackBy) || '') === String(_.get(this.selectedValue, this.trackBy) || '')) return;
          this.fetchOptions({ [this.trackBy]: value || undefined })
              .then(() => {
                this.selectedValue = this.options.find((o) => String(_.get(o, this.trackBy) || '') === String(value || ''))
              })
        }
      }
    },
    selectedValue(value, previousValue) {
      if (this.$attrs.multiple && event) {
        if (JSON.stringify(value) === JSON.stringify(previousValue)) return;
        this.$emit('update:selected', value);
      } else {
        if (value !== previousValue) this.$emit('update:selected', value);
      }
    },
    url(value) {
      this.fetchOptions(value);
    },
    params(value) {
      this.fetchOptions(value);
    }
  },
  methods: {
    onSelect(event) {
      this.$emit('select', event)
    },
    onRemove(event) {
      this.$emit('remove', event)
    },
    onInput(event) {
      this.selectedValue = event;
      if (this.$attrs.multiple && event) {
        this.$emit('input', event.map((d) => _.get(d, this.trackBy)), event);
      }
      else {
        this.$emit('input', _.get(event, this.trackBy), event)
      }
    },
    searchChange(event) {
      this.isLoading = true;
      this.isSearching = true;
      this.search= event
      this.debounceFetchOptions({ search: event || undefined })
    },
    clearAll() {
      this.$emit('input', undefined)
    },
    fetchOptions() {
      if(this.isLoading && !this.isSearching) return Promise.resolve();
      this.isLoading = true;
      return (this.url ? this.$axios.get(this.url, {
        params: {
          [this.searchKey]: this.search,
          per_page: 1000,
          ...this.params
        }
      }) : Promise.resolve({
        data: {data: []}
      })).then(this.modifyResponse || ((response) => (response))).then((response) => {
        const { data: { data } } = response;
        this.options = data;
        this.$emit('loaded', data)
        return response;
      }).finally(() => {
        this.isLoading = false
        this.isSearching = false
        if(this.value !== undefined && this.selectedValue === undefined) {
          this.selectedValue = this.options.find((o) => String(_.get(o, this.trackBy) || '') === String(this.value || ''))
        }
      })
    }
  }
}
</script>

<style scoped>

</style>

<style>
.input-group .multiselect__tags:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.multiselect,
.multiselect__tags,
.multiselect__current,
.multiselect__option {
  min-height: auto;
}
.multiselect__single {
  display: inline;
}
.multiselect,
.multiselect__input,
.multiselect__single,
.multiselect__tags {
  font-size: 12px !important;
  min-height: auto;
  line-height: normal;
}
.multiselect__select {
  height: 34px;
}
</style>
